import { render, staticRenderFns } from "./BaseProductDataForSfra.vue?vue&type=template&id=79486400&"
import script from "./BaseProductDataForSfra.vue?vue&type=script&lang=js&"
export * from "./BaseProductDataForSfra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../sfra-webpack-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/lucia/proyectos/byl_salesforce/sfra-webpack-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79486400')) {
      api.createRecord('79486400', component.options)
    } else {
      api.reload('79486400', component.options)
    }
    module.hot.accept("./BaseProductDataForSfra.vue?vue&type=template&id=79486400&", function () {
      api.rerender('79486400', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app_byl_core/cartridges/app_byl_core/cartridge/client/default/js/vue/components/BaseProductDataForSfra.vue"
export default component.exports